import { render, staticRenderFns } from "./CompetitionEventsItemOld.vue?vue&type=template&id=7c5c5814&scoped=true"
import script from "./CompetitionEventsItemOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionEventsItemOld.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompetitionEventsItemOld.vue?vue&type=style&index=0&id=7c5c5814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c5814",
  null
  
)

export default component.exports